import type { DriveStep } from 'driver.js';

export const dashboardTourSteps: DriveStep[] = [
  {
    element: '[data-onboarding="pipeline-overview"]',
    popover: {
      title: 'Pipeline Overview',
      description: 'This shows the visual flow of cases through the translation pipeline. Each card represents a stage with a count of cases currently in that stage.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="quick-stats"]',
    popover: {
      title: 'Quick Stats',
      description: 'Real-time metrics at a glance:\n- Today Completed: Cases finished today\n- Week Completed: Cases finished this week\n- Processing: Currently being translated\n- Errors: Cases that need attention',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="section-tabs"]',
    popover: {
      title: 'Section Navigation',
      description: 'Click these tabs to switch between different pipeline sections. Each section shows relevant cases and actions.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-onboarding="search-bar"]',
    popover: {
      title: 'Search',
      description: 'Search for cases by case number. The search filters the current section\'s cases in real-time.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-onboarding="bulk-actions"]',
    popover: {
      title: 'Bulk Actions',
      description: 'Select multiple cases using checkboxes, then use these buttons to perform bulk operations like Download, Translate, or Upload.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-onboarding="case-table"]',
    popover: {
      title: 'Case Table',
      description: 'Cases are listed here with relevant columns for the current section. Click a case row to open the review page. Use the action buttons in each row for quick operations.',
      side: 'top',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="refresh-btn"]',
    popover: {
      title: 'Refresh',
      description: 'Manually refresh the case list. The system also auto-refreshes every 30 seconds.',
      side: 'left',
      align: 'center',
    },
  },
];
